import { Button, Drawer, Form, Space, Input, Col, Row, message } from "antd";
import { AiOutlineClose } from "react-icons/ai";
import postDataRoad from "../../../../services/postDataRoad";
export default function CreateOffer({
  isVisible,
  setVisible,
  refetch,
  selected,
}: any) {
  const [form] = Form.useForm();

  const onSubmit = async () => {
    const values = await form.validateFields();
    const uri = `offers`;
    const data = {
      ...values,
      taxrate: 18,
      flattime: 1,
      timetaken: 1,
      labourrate: 0,
      model: selected?._id,
    };
    const response = await postDataRoad(data, uri);
    if (response?.success) {
      message.success("Created Successfully");
      refetch();
      setVisible(false);
    }
  };

  const clearForm = () => {
    form.resetFields();
  };

  const hidePanel = () => {
    setVisible(false);
  };

  return (
    <Drawer
      title={`CREATE OFFER`}
      placement={"right"}
      width={900}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="font-toyota">
        <Form
          id="createOffer"
          form={form}
          name="normal_login"
          className="login-form"
          onFinish={onSubmit}
          layout="vertical"
        >
          <Row gutter={[16, 0]}>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Form.Item
                name="callout_desc"
                label="Call out Description"
                rules={[
                  {
                    required: true,
                    message: "Please enter call out description",
                  },
                ]}
              >
                <Input placeholder="Call out Description" />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Form.Item
                name="invoice_desc"
                label="Invoice description"
                rules={[
                  {
                    required: true,
                    message: "Please enter invoice description",
                  },
                ]}
              >
                <Input placeholder="Invoice description" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 0]}>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Form.Item
                name="partsrate"
                label="Amount ( TZS ) VAT Exclusive"
                rules={[
                  {
                    required: true,
                    message: "Please enter amount",
                  },
                ]}
              >
                <Input type="number" placeholder="Amount" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button danger type="primary" htmlType="submit">
              Create
            </Button>
            <Button
              danger
              htmlType="button"
              className="mx-2"
              onClick={clearForm}
            >
              Reset
            </Button>
            <Button
              danger
              htmlType="button"
              className="mx-2"
              onClick={hidePanel}
            >
              Close
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Drawer>
  );
}
